"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachmentDataUrls = void 0;
const swr_1 = __importDefault(require("swr"));
const utils_1 = require("../utils");
const useAttachmentClient_1 = require("./useAttachmentClient");
/**
 * Generates attachment data URLs and returns an SWR response.
 * SWR `revalidateOnFocus` option is set to `false`.
 *
 * @param attachments - attachments that require Data URL generation
 * @param baseUrl - optional base URL
 * @param tokenProvider - optional token provider
 * @param config - custom SWR configuration object
 */
function useAttachmentDataUrls(attachments, baseUrl, tokenProvider, config) {
    const attachmentClient = (0, useAttachmentClient_1.useAttachmentClient)(baseUrl, tokenProvider);
    return (0, swr_1.default)(attachments ? ['/platform/api/v1/attachment/get/multiple', attachments] : null, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (_a) => __awaiter(this, [_a], void 0, function* ([_, attachments]) {
        if (attachments) {
            const result = [];
            for (const { entity, entityId, key, version } of attachments) {
                result.push(yield (0, utils_1.getImageDataUrl)(attachmentClient, entity, entityId, key, version));
            }
            return result;
        }
        else {
            return undefined;
        }
    }), config !== null && config !== void 0 ? config : {
        revalidateOnFocus: false,
    });
}
exports.useAttachmentDataUrls = useAttachmentDataUrls;
